import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const FIELDS = [
  { id: "current_income", label: "Current monthly take-home", ph: "5000" },
  { id: "monthly_expenses", label: "Monthly essential expenses", ph: "3500" },
  { id: "savings", label: "Current savings", ph: "10000" },
  { id: "side_income_target", label: "Side income target (per month)", ph: "3000" },
  { id: "current_side_income", label: "Current side income (per month)", ph: "0" },
  { id: "emergency_fund_months", label: "Emergency fund months", ph: "6" },
];

export default function ExitCalculator() {
  const [data, setData] = useState({});
  const [out, setOut] = useState({});
  const [date, setDate] = useState("");

  useEffect(() => {
    api.get("/exit").then(r => {
      const e = r.data.exit || {};
      setData(e);
      setOut(e);
      setDate(e.target_quit_date || "");
    });
  }, []);

  const save = async () => {
    try {
      const payload = { ...data, target_quit_date: date, ...FIELDS.reduce((a,f)=>({...a,[f.id]: parseFloat(data[f.id])||0}),{}) };
      const { data: r } = await api.post("/exit", payload);
      setOut(r);
      toast.success("Exit Number saved.");
    } catch { toast.error("Save failed"); }
  };

  const daysToQuit = date ? Math.max(0, Math.round((new Date(date) - Date.now()) / 86400000)) : null;

  return (
    <div className="max-w-3xl mx-auto px-5 pt-6">
      <div className="eyebrow text-[#FD0F10]">EXIT NUMBER CALCULATOR</div>
      <h1 className="font-display text-3xl sm:text-4xl font-black mt-1">Know your finish line.</h1>
      <p className="text-gray-400 text-sm mt-1">Numbers turn dread into a plan. Fill this in. You will feel calmer immediately.</p>

      <div className="mt-6 card-panel p-5 space-y-4">
        {FIELDS.map(f => (
          <div key={f.id}>
            <label className="text-xs font-mono-ui uppercase tracking-wider text-gray-400">{f.label}</label>
            <input type="number" value={data[f.id] ?? ""} onChange={e => setData(d => ({...d, [f.id]: e.target.value}))} placeholder={f.ph} className="w-full mt-1 bg-[#0B0C0E] border border-[#2A2E39] rounded px-4 py-2.5 focus:border-[#FD0F10] outline-none font-mono-ui" data-testid={`exit-${f.id}`} />
          </div>
        ))}
        <div>
          <label className="text-xs font-mono-ui uppercase tracking-wider text-gray-400">Target quit date</label>
          <input type="date" value={date} onChange={e => setDate(e.target.value)} className="w-full mt-1 bg-[#0B0C0E] border border-[#2A2E39] rounded px-4 py-2.5 focus:border-[#FD0F10] outline-none font-mono-ui" data-testid="exit-date" />
        </div>
        <button onClick={save} className="hero-accent text-white font-display font-bold py-3 rounded w-full" data-testid="exit-save">SAVE MY EXIT NUMBER</button>
      </div>

      <div className="mt-6 grid sm:grid-cols-2 gap-3">
        <Stat label="% JOB INCOME REPLACED" value={`${out.pct_job_income_replaced || 0}%`} bar={out.pct_job_income_replaced}/>
        <Stat label="MONTHS OF RUNWAY" value={out.months_runway ?? 0}/>
        <Stat label="EMERGENCY FUND" value={`${out.emergency_fund_pct || 0}%`} bar={out.emergency_fund_pct}/>
        <Stat label="DAYS TO TARGET QUIT" value={daysToQuit ?? "Not set"}/>
      </div>
    </div>
  );
}

function Stat({ label, value, bar }) {
  return (
    <div className="card-panel p-5">
      <div className="eyebrow text-[#FD0F10]">{label}</div>
      <div className="font-display text-3xl font-black mt-2">{value}</div>
      {bar !== undefined && (
        <div className="h-1.5 bg-[#2A2E39] rounded mt-3 overflow-hidden">
          <div className="h-full hero-accent" style={{ width: `${Math.min(100, bar || 0)}%` }} />
        </div>
      )}
    </div>
  );
}
